import { paths } from "@api/api";
import useAxios from "@hooks/useFetch";
import { useEffect, useMemo, useState } from "react";
import { AiSettingsResponse, toByoAiSettings, toTopTrendsAiSettings } from "@apiHooks/aiSearchSettings";

const path: keyof paths = "/Ai/GetSettings";

export function useAiSearchSettings (query: string) {
    const { data: responseData, isLoading } = useAxios<AiSettingsResponse>({
        url: `${path}?query=${encodeURIComponent(query)}`,
        method: "GET",
        lazy: !query,
    });

    const [rawData, setRawData] = useState<AiSettingsResponse | null>(null);

    useEffect(() => {
        if (responseData) {
            setRawData(responseData);
        }
    }, [responseData]);

    useEffect(() => {
        if (isLoading) {
            setRawData(null);
        }
    }, [isLoading]);

    useEffect(() => {
        if (!query) {
            setRawData(null);
        }
    }, [query]);

    const topTrendsSettings = useMemo(() => toTopTrendsAiSettings(rawData), [rawData]);
    const byoSettings = useMemo(() => toByoAiSettings(rawData), [rawData]);

    return {
        isLoading,
        topTrendsSettings,
        byoSettings,
    };
}
